<ng-container>
  <ngx-barcode6
    #barcode
    *ngIf="type !== barcodeType.qr && isValidBarcode"
    [bc-value]="value"
    [bc-format]="renderBarcodeType"
    [bc-element-type]="'svg'"
    [bc-font-size]="12"
    [bc-height]="height"
    [bc-width]="width"
    [bc-background]="'transparent'"
    [bc-display-value]="displayValue"
  >
  </ngx-barcode6>

  <qrcode *ngIf="type === barcodeType.qr" [qrdata]="value" [elementType]="'url'" [width]="100" [errorCorrectionLevel]="'M'"> </qrcode>
</ng-container>
